module.exports = __webpack_public_path__ + "svg/checkbox-white.svg?bb487802c6905bcf5aa6e3ed533f2538";